import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminSettingsEventKeys = {
  ADMIN_API_KEY_COPY: "admin-api-key-copy",
  ADMIN_API_KEY_CREATE_FAILURE: "admin-api-key-create-failure",
  ADMIN_API_KEY_CREATE_SUCCESS: "admin-api-key-create-success",
  ADMIN_API_KEY_DELETE_ATTEMPT: "admin-api-key-delete-attempt",
  ADMIN_API_KEY_DELETE_FAILURE: "admin-api-key-delete-failure",
  ADMIN_API_KEY_DELETE_SUCCESS: "admin-api-key-delete-success",
  ADMIN_API_KEY_FILTER_ACTIVE: "admin-api-key-filter-active",
  ADMIN_API_KEY_FILTER_CREATED_AT: "admin-api-key-filter-created-at",
  ADMIN_API_KEY_FILTER_NAME: "admin-api-key-filter-name",
  ADMIN_AREA_FORM_SUBMIT_ATTEMPT: "admin-area-form-submit-attempt",
  ADMIN_AREA_FORM_SUBMIT_FAILURE: "admin-area-form-submit-failure",
  ADMIN_AREA_FORM_SUBMIT_SUCCESS: "admin-area-form-submit-success",
  ADMIN_AREA_TABLE_FILTER_NAME: "admin-area-filter-name",
  ADMIN_AREA_TABLE_FILTER_STATE: "admin-area-filter-state",
  ADMIN_AREA_TABLE_FILTER_STATUS: "admin-area-filter-status",
  ADMIN_AREA_TABLE_SEARCH: "admin-area-search",
  ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_ATTEMPT:
    "admin-branding-settings-form-submit-attempt",
  ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_FAILURE:
    "admin-branding-settings-form-submit-failure",
  ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_SUCCESS:
    "admin-branding-settings-form-submit-success",
  ADMIN_CATEGORY_FORM_SUBMIT_ATTEMPT: "admin-category-form-submit-attempt",
  ADMIN_CATEGORY_FORM_SUBMIT_FAILURE: "admin-category-form-submit-failure",
  ADMIN_CATEGORY_FORM_SUBMIT_SUCCESS: "admin-category-form-submit-success",
  ADMIN_CATEGORY_TABLE_FILTER_DESCRIPTION: "admin-category-filter-description",
  ADMIN_CATEGORY_TABLE_FILTER_NAME: "admin-category-filter-name",
  ADMIN_CATEGORY_TABLE_FILTER_STATUS: "admin-category-filter-status",
  ADMIN_CATEGORY_TABLE_SEARCH: "admin-category-search",
  ADMIN_ORGANIZATION_SETTINGS_TOGGLE: "admin-organization-settings-toggle",
  ADMIN_SETTINGS_API_KEYS_PAGE_VIEW: "admin-settings-api-keys-page-view",
  ADMIN_SETTINGS_AREAS_PAGE_VIEW: "admin-settings-areas-page-view",
  ADMIN_SETTINGS_BILLING_PAGE_VIEW: "admin-settings-billing-page-view",
  ADMIN_SETTINGS_BRANDING_PAGE_VIEW: "admin-settings-branding-page-view",
  ADMIN_SETTINGS_CATEGORIES_PAGE_VIEW: "admin-settings-categories-page-view",
  ADMIN_SETTINGS_DATA_EXPORT_PAGE_VIEW: "admin-settings-data-export-page-view",
  ADMIN_SETTINGS_EMBED_PAGE_VIEW: "admin-settings-embed-page-view",
  ADMIN_SETTINGS_FEATURES_PAGE_VIEW: "admin-settings-features-page-view",
  ADMIN_SETTINGS_INTEGRATIONS_PAGE_VIEW:
    "admin-settings-integrations-page-view",
  ADMIN_SETTINGS_PAGE_VIEW: "admin-settings-page-view",
  ADMIN_SETTINGS_SECURITY_PAGE_VIEW: "admin-settings-security-page-view",
  ADMIN_SETTINGS_SLUG_PAGE_VIEW: "admin-settings-slug-page-view",
  ADMIN_SETTINGS_TAGS_PAGE_VIEW: "admin-settings-tags-page-view",
  ADMIN_SETTINGS_WEBHOOKS_PAGE_VIEW: "admin-settings-webhooks-page-view",
  ADMIN_TAG_DELETE_ATTEMPT: "admin-tag-delete-attempt",
  ADMIN_TAG_DELETE_CANCEL: "admin-tag-delete-cancel",
  ADMIN_TAG_DELETE_FAILURE: "admin-tag-delete-failure",
  ADMIN_TAG_DELETE_SUCCESS: "admin-tag-delete-success",
  ADMIN_TAG_FORM_SUBMIT_ATTEMPT: "admin-tag-form-submit-attempt",
  ADMIN_TAG_FORM_SUBMIT_SUCCESS: "admin-tag-form-submit-success",
  ADMIN_TAG_TABLE_FILTER_NAME: "admin-tag-filter-name",
  ADMIN_TAG_TABLE_SEARCH: "admin-tag-search",
  ADMIN_ZAPIER_DOCS_CLICK: "admin-zapier-docs-click",
  ADMIN_ZAPIER_SAVE_FAILURE: "admin-zapier-save-failure",
  ADMIN_ZAPIER_SAVE_SUCCESS: "admin-zapier-save-success",
  ADMIN_ZAPIER_TEST_FAILURE: "admin-zapier-test-failure",
  ADMIN_ZAPIER_TEST_SUCCESS: "admin-zapier-test-success",
  ADMIN_ZAPIER_TOGGLE: "admin-zapier-toggle",
} as const;

export const AdminSettingsEventCatalog: EventCatalogFromKeys<
  typeof AdminSettingsEventKeys
> = {
  [AdminSettingsEventKeys.ADMIN_SETTINGS_API_KEYS_PAGE_VIEW]: {
    description: "Admin viewed the API keys settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_API_KEYS_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_AREAS_PAGE_VIEW]: {
    description: "Admin viewed the areas settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_AREAS_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_BILLING_PAGE_VIEW]: {
    description: "Admin viewed the billing settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_BILLING_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_BRANDING_PAGE_VIEW]: {
    description: "Admin viewed the branding settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_BRANDING_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_CATEGORIES_PAGE_VIEW]: {
    description: "Admin viewed the categories settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_CATEGORIES_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_DATA_EXPORT_PAGE_VIEW]: {
    description: "Admin viewed the data export settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_DATA_EXPORT_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_EMBED_PAGE_VIEW]: {
    description: "Admin viewed the embed code settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_EMBED_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_INTEGRATIONS_PAGE_VIEW]: {
    description: "Admin viewed the integrations settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_INTEGRATIONS_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_PAGE_VIEW]: {
    description: "Admin viewed the main settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_SECURITY_PAGE_VIEW]: {
    description: "Admin viewed the security settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_SECURITY_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_SLUG_PAGE_VIEW]: {
    description: "Admin viewed the organization slug settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_SLUG_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_TAGS_PAGE_VIEW]: {
    description: "Admin viewed the tags settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_TAGS_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_WEBHOOKS_PAGE_VIEW]: {
    description: "Admin viewed the webhooks settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_WEBHOOKS_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_SETTINGS_FEATURES_PAGE_VIEW]: {
    description: "Admin viewed the features settings page",
    eventType: EventType.PAGE_VIEW,
    id: AdminSettingsEventKeys.ADMIN_SETTINGS_FEATURES_PAGE_VIEW,
  },
  [AdminSettingsEventKeys.ADMIN_ORGANIZATION_SETTINGS_TOGGLE]: {
    description: "Admin toggled an organization setting",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_ORGANIZATION_SETTINGS_TOGGLE,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_CREATE_SUCCESS]: {
    description: "Admin created an API key successfully",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_CREATE_SUCCESS,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_CREATE_FAILURE]: {
    description: "Admin failed to create an API key",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_CREATE_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_DELETE_ATTEMPT]: {
    description: "Admin attempted to delete an API key",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_DELETE_ATTEMPT,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_DELETE_SUCCESS]: {
    description: "Admin deleted an API key successfully",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_DELETE_SUCCESS,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_DELETE_FAILURE]: {
    description: "Admin failed to delete an API key",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_DELETE_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_COPY]: {
    description: "Admin copied an API key to clipboard",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_COPY,
  },
  // Zapier integration events
  [AdminSettingsEventKeys.ADMIN_ZAPIER_TOGGLE]: {
    description: "Admin toggled Zapier integration on/off",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_ZAPIER_TOGGLE,
  },
  [AdminSettingsEventKeys.ADMIN_ZAPIER_SAVE_SUCCESS]: {
    description: "Admin saved Zapier integration settings successfully",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_ZAPIER_SAVE_SUCCESS,
  },
  [AdminSettingsEventKeys.ADMIN_ZAPIER_SAVE_FAILURE]: {
    description: "Admin failed to save Zapier integration settings",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_ZAPIER_SAVE_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_ZAPIER_TEST_SUCCESS]: {
    description: "Admin successfully tested Zapier webhook",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_ZAPIER_TEST_SUCCESS,
  },
  [AdminSettingsEventKeys.ADMIN_ZAPIER_TEST_FAILURE]: {
    description: "Admin failed to test Zapier webhook",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_ZAPIER_TEST_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_ZAPIER_DOCS_CLICK]: {
    description: "Admin clicked the Zapier docs link",
    eventType: EventType.BUTTON_CLICK,
    id: AdminSettingsEventKeys.ADMIN_ZAPIER_DOCS_CLICK,
  },
  // Category form submit events
  [AdminSettingsEventKeys.ADMIN_CATEGORY_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the category form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_FORM_SUBMIT_ATTEMPT,
  },
  [AdminSettingsEventKeys.ADMIN_CATEGORY_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the category form",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_FORM_SUBMIT_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_CATEGORY_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the category form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_FORM_SUBMIT_SUCCESS,
  },
  // Tag form submit events
  [AdminSettingsEventKeys.ADMIN_TAG_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the tag form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_TAG_FORM_SUBMIT_ATTEMPT,
  },

  [AdminSettingsEventKeys.ADMIN_TAG_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the tag form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_TAG_FORM_SUBMIT_SUCCESS,
  },
  // Area form submit events
  [AdminSettingsEventKeys.ADMIN_AREA_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the area form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_AREA_FORM_SUBMIT_ATTEMPT,
  },
  [AdminSettingsEventKeys.ADMIN_AREA_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the area form",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_AREA_FORM_SUBMIT_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_AREA_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the area form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_AREA_FORM_SUBMIT_SUCCESS,
  },
  // Branding settings form submit events
  [AdminSettingsEventKeys.ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the branding settings form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_ATTEMPT,
  },
  [AdminSettingsEventKeys.ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the branding settings form",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the branding settings form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminSettingsEventKeys.ADMIN_BRANDING_SETTINGS_FORM_SUBMIT_SUCCESS,
  },
  [AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_FILTER_DESCRIPTION]: {
    description: "Admin filtered categories by description",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_FILTER_DESCRIPTION,
  },
  [AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_FILTER_NAME]: {
    description: "Admin filtered categories by name",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_FILTER_NAME,
  },
  [AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_FILTER_STATUS]: {
    description: "Admin filtered categories by status",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_FILTER_STATUS,
  },
  [AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_SEARCH]: {
    description: "Admin searched for a category",
    eventType: EventType.FILTER,
    id: AdminSettingsEventKeys.ADMIN_CATEGORY_TABLE_SEARCH,
  },
  [AdminSettingsEventKeys.ADMIN_TAG_TABLE_FILTER_NAME]: {
    description: "Admin filtered tags by name",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_TAG_TABLE_FILTER_NAME,
  },
  [AdminSettingsEventKeys.ADMIN_TAG_TABLE_SEARCH]: {
    description: "Admin searched for a tag",
    eventType: EventType.FILTER,
    id: AdminSettingsEventKeys.ADMIN_TAG_TABLE_SEARCH,
  },
  [AdminSettingsEventKeys.ADMIN_AREA_TABLE_FILTER_NAME]: {
    description: "Admin filtered areas by name",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_AREA_TABLE_FILTER_NAME,
  },
  [AdminSettingsEventKeys.ADMIN_AREA_TABLE_FILTER_STATE]: {
    description: "Admin filtered areas by state",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_AREA_TABLE_FILTER_STATE,
  },
  [AdminSettingsEventKeys.ADMIN_AREA_TABLE_FILTER_STATUS]: {
    description: "Admin filtered areas by status",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_AREA_TABLE_FILTER_STATUS,
  },
  [AdminSettingsEventKeys.ADMIN_AREA_TABLE_SEARCH]: {
    description: "Admin searched for an area",
    eventType: EventType.FILTER,
    id: AdminSettingsEventKeys.ADMIN_AREA_TABLE_SEARCH,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_FILTER_ACTIVE]: {
    description: "Admin filtered API keys by active status",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_FILTER_ACTIVE,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_FILTER_CREATED_AT]: {
    description: "Admin filtered API keys by created at",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_FILTER_CREATED_AT,
  },
  [AdminSettingsEventKeys.ADMIN_API_KEY_FILTER_NAME]: {
    description: "Admin filtered API keys by name",
    eventType: EventType.TABLE_FILTER,
    id: AdminSettingsEventKeys.ADMIN_API_KEY_FILTER_NAME,
  },
  [AdminSettingsEventKeys.ADMIN_TAG_DELETE_ATTEMPT]: {
    description: "Admin attempted to delete a tag",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_TAG_DELETE_ATTEMPT,
  },
  [AdminSettingsEventKeys.ADMIN_TAG_DELETE_CANCEL]: {
    description: "Admin cancelled tag deletion",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_TAG_DELETE_CANCEL,
  },
  [AdminSettingsEventKeys.ADMIN_TAG_DELETE_FAILURE]: {
    description: "Admin failed to delete a tag",
    eventType: EventType.ERROR,
    id: AdminSettingsEventKeys.ADMIN_TAG_DELETE_FAILURE,
  },
  [AdminSettingsEventKeys.ADMIN_TAG_DELETE_SUCCESS]: {
    description: "Admin successfully deleted a tag",
    eventType: EventType.INTERACTION,
    id: AdminSettingsEventKeys.ADMIN_TAG_DELETE_SUCCESS,
  },
};
